import { BarChartProps } from '@mui/x-charts';
import {
  SingleOrDoubleAxisConfig,
  XAxisConfig,
  YAxisConfig,
} from '../common/common-chart-types';
import {
  getMarginsForNonHorizontalCharts,
  getModifiedXAxisConfigs,
  getPlotSideMargins,
  ModifiedXAxisConfig,
  XTickLabelOptions,
} from '../common/common-chart-utils/common-chart-display-utils';
import { MuiLineChartDataConfig } from './line-chart-types';

export const getModifiedXAxisConfigsLineChart = (
  {
    isHorizontal,
    xAxisConfigs,
  }: {
    isHorizontal: boolean;
    xAxisConfigs: SingleOrDoubleAxisConfig<XAxisConfig<any>>;
  },
  dataset: BarChartProps['dataset'],
  elementWidth: number,
  options?: XTickLabelOptions
): SingleOrDoubleAxisConfig<ModifiedXAxisConfig<any>> => {
  return getModifiedXAxisConfigs(
    { isHorizontal, xAxisConfigs },
    dataset,
    elementWidth,
    options
  );
};

// line chart last tick margin spills to the right,
// so without this extra margin it gets cut off
const LINE_CHART_EXTRA_RIGHT_MARGIN = 20;

// Width the lines span, used to size x tick labels before the margins are final
export const getPlotWidthLineChart = (
  yAxisConfigs: SingleOrDoubleAxisConfig<YAxisConfig<any>> | undefined,
  series: MuiLineChartDataConfig['series'],
  dataset: BarChartProps['dataset'] = [],
  elementWidth: number,
  showLegend = false
) => {
  const { left, right } = getPlotSideMargins(
    yAxisConfigs,
    series,
    dataset,
    elementWidth,
    showLegend
  );
  return elementWidth - left - right - LINE_CHART_EXTRA_RIGHT_MARGIN;
};

export const getMarginsLineChart = (
  xAxisConfigs: SingleOrDoubleAxisConfig<ModifiedXAxisConfig<any>>,
  yAxisConfigs: SingleOrDoubleAxisConfig<YAxisConfig<any>> | undefined,
  series: MuiLineChartDataConfig['series'],
  dataset: BarChartProps['dataset'] = [],
  elementWidth: number,
  showLegend: boolean = false
) => {
  const commonMargins = getMarginsForNonHorizontalCharts(
    xAxisConfigs,
    yAxisConfigs,
    series,
    dataset,
    elementWidth,
    showLegend
  );
  return {
    ...commonMargins,
    // Not sure if this is ideal behaviour but this closer to
    // what we had and looks normal
    right: commonMargins.right + LINE_CHART_EXTRA_RIGHT_MARGIN,
  };
};
